/*eslint-disable */
/**
 * 导入svgIcon/svg下的所有svg文件
 * @param requireContext
 * @returns {*}
 */
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);